import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IEnvironmentService } from '../environment/environment.interface';
import { IIconsService } from './icons.interface';

@Injectable()
export class IconsService implements IIconsService {
  private dataApi: string;
  public icons$ = new BehaviorSubject(null);

  constructor(@Inject('IEnvironmentService') private envService: IEnvironmentService, private http: HttpClient) {
    this.dataApi = this.envService.getVar('services.api') as string;
  }

  getIconsFromServer(): Observable<any> {
    return this.http.get(`${this.dataApi}/icons`);
  }

  getIcons(): Observable<any> {
    return this.icons$.asObservable();
  }
}
